import { Construction } from 'lucide-react';

import { useTranslation } from '../../context/LanguageContext';
import type { TranslationKey } from '../../i18n';

/**
 * A tab that has a route and a sidebar entry but no implementation yet.
 *
 * Deliberately blunt rather than a mocked-up empty state: the surrounding phases
 * build these one at a time, and a placeholder that looks like a real but empty
 * feature is indistinguishable from a broken one. Saying which phase owns it
 * means nobody files a bug against work that has not started.
 */
export function PlaceholderPage({
  titleKey,
  bodyKey,
}: Readonly<{ titleKey: TranslationKey; bodyKey: TranslationKey }>) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex max-w-md flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-slate-200 bg-white">
        <Construction className="h-5 w-5 text-slate-400" />
      </div>
      <p className="text-sm font-semibold text-slate-700">{t(titleKey)}</p>
      <p className="mt-1.5 text-xs leading-relaxed text-slate-500">{t(bodyKey)}</p>
    </div>
  );
}
